import React, { useState, lazy } from 'react';
import { StarIcon } from 'lucide-react';
export const Endorsements = () => {
  const [currentImage, setCurrentImage] = useState(0);
  const images = ['https://uploadthingy.s3.us-west-1.amazonaws.com/khXFHmwHiKgbcpvHjPWX3A/Generated_Image_October_01%2C_2025_-_11_13PM.png', 'https://uploadthingy.s3.us-west-1.amazonaws.com/ihan3ZYeuAXuUFSFpUDknM/Generated_Image_October_01%2C_2025_-_11_15PM.png', 'https://uploadthingy.s3.us-west-1.amazonaws.com/su35FcB6syZNv5W6GAXhRV/Generated_Image_October_01%2C_2025_-_11_10PM.png', 'https://uploadthingy.s3.us-west-1.amazonaws.com/6eMhkb869QgLvuK2EHd1jF/Generated_Image_October_01%2C_2025_-_11_16PM.png', 'https://uploadthingy.s3.us-west-1.amazonaws.com/tov21G1cmWhUCmWBQUVZAe/Generated_Image_October_01%2C_2025_-_11_33PM.png'];
  return <div className="py-12 bg-gray-50 relative border-y border-gray-200" data-id="element-40">
      {/* Stars background */}
      <div className="absolute top-0 left-0 w-full h-full opacity-5 pointer-events-none" data-id="element-41">
        <div className="w-full h-full bg-repeat" style={{
        backgroundImage: "url('https://www.transparenttextures.com/patterns/stars.png')"
      }} data-id="element-42"></div>
      </div>
      <div className="container mx-auto px-4 max-w-4xl relative z-10" data-id="element-43">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-8 text-center" data-id="element-44">
          Trusted & Endorsed by Patriots Nationwide
        </h2>
        {/* Main testimonial */}
        <div className="bg-white p-6 rounded-lg shadow-md border-l-4 border-red-700 mb-8" data-id="element-45">
          <blockquote className="text-xl italic font-medium text-gray-800 mb-2" data-id="element-46">
            "A powerful book every American should read."
          </blockquote>
          <div className="flex justify-between items-center" data-id="element-47">
            <p className="font-bold text-blue-800" data-id="element-48">
              – Charlie Kirk, Turning Point USA
            </p>
            <div className="flex" data-id="element-49">
              {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 text-yellow-500 fill-current" data-id="element-50" />)}
            </div>
          </div>
        </div>
        {/* Testimonial grid */}
        <div className="grid md:grid-cols-2 gap-6 mb-10" data-id="element-51">
          {/* Veteran testimonial */}
          <div className="bg-white p-5 rounded-lg shadow-md" data-id="element-52">
            <div className="flex mb-2" data-id="element-53">
              {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 text-yellow-500 fill-current" data-id="element-54" />)}
            </div>
            <blockquote className="text-gray-800 italic mb-3" data-id="element-55">
              "Finally, a book that speaks the truth they don't want you to
              hear."
            </blockquote>
            <p className="font-bold text-gray-700" data-id="element-56">– John M., U.S. Veteran</p>
          </div>
          {/* Mom testimonial */}
          <div className="bg-white p-5 rounded-lg shadow-md" data-id="element-57">
            <div className="flex mb-2" data-id="element-58">
              {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 text-yellow-500 fill-current" data-id="element-59" />)}
            </div>
            <blockquote className="text-gray-800 italic mb-3" data-id="element-60">
              "As a mom, this gave me hope that our kids still have a future
              worth fighting for."
            </blockquote>
            <p className="font-bold text-gray-700" data-id="element-61">– Sarah K., Patriot Mom</p>
          </div>
        </div>
        {/* Media logos section */}

        {/* Media note */}
        <p className="text-center text-gray-700 italic mb-8" data-id="element-62">
          (The mainstream media refuses to touch this book—and that's exactly
          why patriots everywhere are buying it.)
        </p>
        {/* Scarcity message */}
        <div className="bg-blue-50 border-l-4 border-blue-700 p-4 text-center" data-id="element-63">
          <p className="font-bold text-gray-800" data-id="element-64">
            Over 50,000 copies already in the hands of patriots nationwide.
            Don't wait—join the movement.
          </p>
        </div>
        {/* Image Carousel */}
        <div className="mt-10 mb-8" data-id="element-65">
          <h3 className="text-xl font-bold text-center mb-6" data-id="element-66">
            Patriots Across America With Their Copy
          </h3>
          <div className="relative" data-id="element-67">
            {/* Carousel Container */}
            <div className="overflow-hidden rounded-lg shadow-md" data-id="element-68">
              <div className="flex transition-transform duration-500 ease-in-out" style={{
              transform: `translateX(-${currentImage * 100}%)`
            }} data-id="element-69">
                <div className="w-full flex-shrink-0" data-id="element-70">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/khXFHmwHiKgbcpvHjPWX3A/Generated_Image_October_01%2C_2025_-_11_13PM.png" alt="Woman with black shirt holding Charlie Kirk book" className="w-full h-auto object-cover" loading="lazy" data-id="element-71" />
                </div>
                <div className="w-full flex-shrink-0" data-id="element-72">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/ihan3ZYeuAXuUFSFpUDknM/Generated_Image_October_01%2C_2025_-_11_15PM.png" alt="Woman in kitchen with Charlie Kirk book" className="w-full h-auto object-cover" loading="lazy" data-id="element-73" />
                </div>
                <div className="w-full flex-shrink-0" data-id="element-74">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/su35FcB6syZNv5W6GAXhRV/Generated_Image_October_01%2C_2025_-_11_10PM.png" alt="Woman in white sweater with Charlie Kirk book" className="w-full h-auto object-cover" loading="lazy" data-id="element-75" />
                </div>
                <div className="w-full flex-shrink-0" data-id="element-76">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6eMhkb869QgLvuK2EHd1jF/Generated_Image_October_01%2C_2025_-_11_16PM.png" alt="Man in blue shirt with Charlie Kirk book" className="w-full h-auto object-cover" loading="lazy" data-id="element-77" />
                </div>
                <div className="w-full flex-shrink-0" data-id="element-78">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/tov21G1cmWhUCmWBQUVZAe/Generated_Image_October_01%2C_2025_-_11_33PM.png" alt="Man in yellow shirt with Charlie Kirk book" className="w-full h-auto object-cover" loading="lazy" data-id="element-79" />
                </div>
              </div>
            </div>
            {/* Navigation Buttons */}
            <button onClick={() => setCurrentImage(prev => prev === 0 ? images.length - 1 : prev - 1)} className="absolute left-2 top-1/2 -translate-y-1/2 bg-white bg-opacity-70 hover:bg-opacity-100 rounded-full p-2 shadow-md z-10" aria-label="Previous image" data-id="element-80">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-81">
                <path d="M15 18l-6-6 6-6" data-id="element-82" />
              </svg>
            </button>
            <button onClick={() => setCurrentImage(prev => prev === images.length - 1 ? 0 : prev + 1)} className="absolute right-2 top-1/2 -translate-y-1/2 bg-white bg-opacity-70 hover:bg-opacity-100 rounded-full p-2 shadow-md z-10" aria-label="Next image" data-id="element-83">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-84">
                <path d="M9 18l6-6-6-6" data-id="element-85" />
              </svg>
            </button>
            {/* Indicators */}
            <div className="flex justify-center mt-4" data-id="element-86">
              {images.map((_, index) => <button key={index} onClick={() => setCurrentImage(index)} className={`w-3 h-3 mx-1 rounded-full ${currentImage === index ? 'bg-blue-700' : 'bg-gray-300'}`} aria-label={`Go to image ${index + 1}`} data-id="element-87" />)}
            </div>
          </div>
          <p className="text-center text-gray-700 mt-4 italic" data-id="element-88">
            Real Americans sharing their copies of this important book
          </p>
        </div>
      </div>
    </div>;
};